import ThemePluginFilesMigration from './ThemePluginFilesMigration';
import {handleAjaxError} from 'src/wp-migrate-db-pro/asset/src/js/helpers/utils';

const $ = window.jQuery;
const wpmdb = window.wpmdb;
const ajaxurl = window.ajaxurl;

/**
 * Base class for organizing the Theme & Plugin Files specific options
 */
export default class ThemePluginFilesBase {

	constructor() {
		this.themesCheckBox = document.getElementById( 'migrate_themes' );
		this.themesSelector = document.getElementById( 'select-themes' );
		this.pluginsCheckBox = document.getElementById( 'migrate_plugins' );
		this.pluginsSelector = document.getElementById( 'select-plugins' );
		this.themesPluginsWrappers = document.getElementsByClassName( 'themes-plugins-options' );
		this.filtered = false;

		// Initialize t_and_p object on the WPMDB object
		wpmdb.t_and_p = {
			remote_connection_data: {}
		};

		$( document ).ready( () => {
			this.hooks();

			$( '.migrate-db-button' ).bindFirst( 'click', function( e ) {

				if ( -1 === [ 'push', 'pull' ].indexOf( wpmdb.functions.wpmdb_migration_type() ) ) {
					return false;
				}

				if ( $( '#migrate_themes' ).is( ':checked' ) && null === $( '#select-themes' ).val() ) {
					alert( window.wpmdbtp_settings.strings.select_themes );

					e.stopImmediatePropagation();
					return false;
				}

				if ( $( '#migrate_plugins' ).is( ':checked' ) && null === $( '#select-plugins' ).val() ) {
					alert( window.wpmdbtp_settings.strings.select_plugins );

					e.stopImmediatePropagation();
					return false;
				}
			} );
		} );

		return new ThemePluginFilesMigration();
	}

	/**
	 * Actions to run on WPMDB's hooks
	 */
	hooks() {
		$.wpmdb.add_action( 'move_connection_info_box', () => {
			$( this.themesPluginsWrappers ).addClass( 'hidden' );
			$( '.themes-plugins-errors' ).hide();
			$( '.exclude-paths' ).hide();
			this.maybeShowExcludes();
		} );

		// Only trigger if connecting to a remote site
		$.wpmdb.add_action( 'verify_connection_to_remote_site', this.verify_connection_to_remote, '', this );
	}

	verify_connection_to_remote( connection_data ) {
		const migration_type = wpmdb.functions.wpmdb_migration_type();

		wpmdb.t_and_p.remote_connection_data = connection_data;
		wpmdb.t_and_p.remote_theme_plugin_files_available = connection_data.remote_theme_plugin_files_available;

		// If addon isn't activated on remote...
		if ( 'undefined' === typeof wpmdb.t_and_p.remote_theme_plugin_files_available ) {
			$( '.themes-plugins-migration-unavailable' ).show();
			this.hide_show_options();
			return false;
		}

		if ( 'undefined' !== typeof wpmdb.t_and_p.remote_connection_data.theme_plugin_files_version &&
		     wpmdb_data.theme_plugin_files_version !== wpmdb.t_and_p.remote_connection_data.theme_plugin_files_version ) {
			$( '.themes-plugins-remote-location' ).html( wpmdb.t_and_p.remote_connection_data.url );
			$( '.themes-plugins-remote-version' ).html( wpmdb.t_and_p.remote_connection_data.theme_plugin_files_version );
			$( '.themes-plugins-different-plugin-version-notice' ).show();

			this.hide_show_options();
			return false;
		}

		if ( -1 !== [ 'push', 'pull' ].indexOf( migration_type ) ) {
			$( this.themesPluginsWrappers ).removeClass( 'hidden' );
			this.populateThemeList( migration_type );
			this.populatePluginList( migration_type );
		}

		return true;
	}

	hide_show_options() {
		$( '.themes-plugins-errors' ).show();

		// Uncheck options
		$( '#migrate_themes' ).prop( 'checked', false );
		$( '#migrate_plugins' ).prop( 'checked', false );

		$( '.themes-plugins-options' ).addClass( 'hidden' );

		$( this.themesPluginsWrappers )
			.removeClass( 'hidden' )
			.addClass( 'disabled' )
			.find( '.select-wrap' )
			.hide();

		$( this.themesPluginsWrappers )
			.find( '*' )
			.attr( 'disabled', 'disabled' );

		$( '.exclude-paths' ).addClass( 'disabled' ).find( '.expandable-content' ).hide();
		$( '.exclude-paths .header-expand-collapse' ).unbind( 'click' );
	}

	/**
	 * Get either themes or plugins data (remote or local) from the site_details global
	 *
	 * @param migration_type
	 * @param type
	 * @returns {*}
	 */
	getSiteData( migration_type, type ) {
		let data = wpmdb_data.site_details[ type ];
		if ( 'pull' === migration_type ) {
			data = wpmdb.t_and_p.remote_connection_data.site_details[ type ];
		}

		return data;
	}

	/**
	 *
	 * @param args
	 * @returns {Promise.<*>}
	 *
	 * @TODO move to util class
	 */
	async getData( nonce, action ) {
		const args = {
			action: action,
			nonce: nonce
		};

		return await $.ajax( {
			url: ajaxurl,
			type: 'POST',
			cache: false,
			data: args
		} );
	}

	populateThemeList( migration_type ) {
		let theme_data = this.getSiteData( migration_type, 'themes' );
		this.populateSelect( this.filterThemes( theme_data ), this.themesSelector, 'themes' );
	}

	populatePluginList( migration_type ) {
		let plugin_data = this.getSiteData( migration_type, 'plugins' );
		this.populateSelect( plugin_data, this.pluginsSelector, 'plugins' );
	}

	/**
	 *
	 * Filters the list of themes by adding '(active)' to the theme name
	 *
	 * @return object filtered_object
	 * @param obj
	 */
	filterThemes( obj ) {

		//Make copy of the object, apparently this is still the fastest hack https://stackoverflow.com/a/5344074/130596
		const filtered_obj = JSON.parse( JSON.stringify( obj ) );

		for ( const prop in obj ) {
			const old_name = obj[ prop ][ 0 ].name;

			if ( obj[ prop ][ 0 ].active ) {
				filtered_obj[ prop ][ 0 ].name = `${old_name} ${window.wpmdbtp_settings.strings.theme_active}`;
			} else {
				filtered_obj[ prop ][ 0 ].name = old_name;
			}
		}

		return filtered_obj;
	}

	/**
	 * Determine if theme or plugin is in the loaded profile.
	 *
	 * @TODO also load from localStorage when the profile isn't saved
	 *
	 * @param prop
	 * @param type
	 * @returns {*}
	 */
	filterProfile( prop, type ) {
		if ( true === wpmdb_default_profile ) {
			return 'themes' === type ? prop.active : false;
		}

		let profile = window.wpmdbtp_settings.loaded_profile;
		let selected = profile[ `select_${type}` ];

		if ( !selected || 0 === selected.length ) {
			return prop;
		}

		if ( -1 !== selected.indexOf( prop.path ) ) {
			return true;
		}
	}

	/**
	 * Populate Theme & Plugin select lists
	 *
	 * @param obj
	 * @param selector
	 * @param type
	 * // @TODO check if file exists on filesystem
	 */
	populateSelect( obj, selector, type ) {

		// Empty <option> out each time it's called
		selector.innerHTML = '';

		for ( const prop in obj ) {
			let opt = document.createElement( 'option' );

			opt.value = obj[ prop ][ 0 ].path;
			opt.text = obj[ prop ][ 0 ].name;

			//If the plugin/theme is in the loaded profile, set selected
			const item_active = this.filterProfile( obj[ prop ][ 0 ], type );

			if ( item_active ) {
				opt.selected = 'selected';
			}

			selector.appendChild( opt );
		}
	}

	showExcludes( element ) {
		element.show();
		element.find( '.expandable-content' ).show();
		element.find( '.expand-collapse-arrow' ).removeClass( 'collapsed' );
	}

	maybeShowExcludes() {
		let $excludes = $( '.exclude-paths' );
		let $themes_plugins_checkboxes = $( '.themes-plugins-toggle' );

		if ( $themes_plugins_checkboxes.is( ':checked' ) && -1 !== [
			'push',
			'pull'
		].indexOf( wpmdb.functions.wpmdb_migration_type() ) ) {
			this.showExcludes( $excludes );
		}

		$themes_plugins_checkboxes.on( 'change', () => {
			if ( $themes_plugins_checkboxes.is( ':checked' ) ) {
				this.showExcludes( $excludes );
			} else {
				$excludes.hide();
				$excludes.find( '.expandable-content' ).hide();
				$excludes.find( '.expand-collapse-arrow' ).addClass( 'collapsed' );
			}
		} );
	}
}




// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/src/js/class/ThemePluginFilesBase.js